<vdr-card
  [title]="'userLevel.customer-level-setter' | translate"
  style="margin-bottom: 20px"
>
  <div class="form-grid">
    <vdr-form-field [label]="'userLevel.customer-levels' | translate">
      <select [(ngModel)]="currentLevelId" (ngModelChange)="setLevel($event)">
        <option
          *ngFor="let level of availableLevels$ | async"
          [value]="level.id"
        >
          {{ level.name }}
        </option>
      </select>
    </vdr-form-field>
    <div></div>
    <vdr-form-field [label]="'userLevel.accuPoint' | translate">
      {{ accuPoint }}
    </vdr-form-field>
    <vdr-form-field [label]="'common.spent' | translate">
      <ng-container *ngIf="currencyCode; else plainSpent">
        {{ moneySpent | currency: currencyCode : "symbol" : "1.0-2" }}
      </ng-container>
      <ng-template #plainSpent>{{ moneySpent }}</ng-template>
    </vdr-form-field>
  </div>
</vdr-card>
